// @ts-strict-ignore
import { Injectable } from '@angular/core';
import { ApiService, BaseApiService } from '@fc-core/services/base-api.service';
import { expand, map } from 'rxjs/operators';
import { EMPTY, Observable } from 'rxjs';
import { VehicleGroup } from '@fc-core/models';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
@ApiService({ baseName: 'vehicle-groups' })
export class VehicleTypeApiService extends BaseApiService {
  constructor(private http: HttpClient) {
    super();
  }

  public static fromJSON<T extends VehicleGroup>(vehicleType: any): T {
    return { ...vehicleType };
  }

  // TODO: replace hand-rolled pagination loop with fetchAllPages (@fc-shared/utils/request-utils/fetch-all-pages)
  loadAll(): Observable<VehicleGroup[]> {
    return this.http.get<{ results: VehicleGroup[] }>(this.getUrl()).pipe(
      expand((results: { results: VehicleGroup[]; next?: string }) => {
        if (!!results['next']) {
          return this.http.get<{ results: VehicleGroup[] }>(results['next']);
        } else {
          return EMPTY;
        }
      }),
      map((res: { results: VehicleGroup[] }) =>
        res.results.sort((a, b) => a.name.localeCompare(b.name)),
      ),
    );
  }

  delete(id: number): Observable<any> {
    return this.http.delete(this.getUrl(id));
  }

  create(vehicleGroup: VehicleGroup): Observable<VehicleGroup> {
    return this.http.post(this.getUrl(), vehicleGroup).pipe(
      map((res) => {
        return VehicleTypeApiService.fromJSON<VehicleGroup>(res);
      }),
    );
  }

  update(vehicleType: VehicleGroup): Observable<VehicleGroup> {
    return this.http.patch(this.getUrl(vehicleType.id), vehicleType).pipe(
      map((res) => {
        return VehicleTypeApiService.fromJSON<VehicleGroup>(res);
      }),
    );
  }

  removeVehicleFromGroup(
    groupId: number,
    vehicleId: number,
  ): Observable<VehicleGroup> {
    return this.http.post(
      `${environment.apiUrl}api/vehicle-groups/${groupId}/remove/`,
      {
        vehicles: [vehicleId],
      },
    );
  }

  addVehiclesToGroup(
    groupId: number,
    vehiclesIds: number[],
  ): Observable<VehicleGroup> {
    return this.http.post(
      `${environment.apiUrl}api/vehicle-groups/${groupId}/add/`,
      {
        vehicles: vehiclesIds,
      },
    );
  }

  getDefaultColor(): Observable<string[]> {
    return this.http.get<string[]>(`${environment.apiUrl}api/colors/random/`);
  }
}
